<template>
  <div
    class="autorizzazioni-ferie-mobile mobile_customize col-xs-24" :style="{ height: (tableHeight) + 'px !important'}"
    v-loading="loading"
  >
    <div class="row row-custom">  
      <div class="mobile-title col-24 no-padding">{{ $t('ferie.titoloAuth') }}</div>
    </div>
    <div class="elemento row row-custom">
      <div class="my-label col-24 no-padding">{{ $t('country.label')}}</div>
      <div class="my-value col-24 no-padding">
        <div class="select-wrapper">
          <select v-model="country" @change="change">
            <option
              v-for="(item, index) in countries"
              :value="item.codice"
              :key="index"
            >{{ ($t('country.'+item.codice)) }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="elemento row row-custom">
      <div class="my-label col-24 no-padding">{{ $t('ferie.stato')}}</div>
      <div class="my-value col-24 no-padding">
        <div class="select-wrapper">
          <select v-model="statoRich" @change="change">
            <option
              v-for="(item, index) in stati"
              :value="item"
              :key="index"
            >{{ ($t('ferie.status.'+item+'_des')) }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="elemento row row-custom">
      <div class="my-label col-12 no-padding center">{{ $t('ferie.anno')}}</div>
      <div class="my-label col-12 no-padding center">{{ $t('ferie.vip')}}</div>
      <div class="my-value col-12 no-padding">
        <div class="select-wrapper">
          <select v-model="anno" @change="change">
            <option
              v-for="(item, index) in anni"
              :value="item"
              :key="index"
            >{{ item }}</option>
          </select>
        </div>
      </div>
      <div class="my-value col-12 no-padding">
        <el-switch
          v-model="vipChecked"
          active-color="#007c74"
          @change="change">
        </el-switch>
      </div>
    </div>
    <!--<div class="elemento row row-custom">
      <div class="my-label col-18 no-padding">{{ $t('ferie.vip')}}</div>
      <div class="my-value col-6 no-padding">
        <el-switch
          v-model="vipChecked"
          active-color="#007c74"
          @change="change">
        </el-switch>
      </div>
    </div>-->

    <div class="elenco-ferie col-24 no-padding">
      <div v-for="(item,index) in richiesteSub" :key="index" class="scheda" :class="[item.seGest === 'S' ? 'segest' : '', item.stato]">
        <div class="riga">
          <span class="nominativo">
            {{ item.cognome + ' ' + item.nome }}
          </span>
          <icon v-if="(item.seGest === 'S')" class="pointer rej" name="riv-reject" scale="1.5" @click.native="rifiuta(item)"></icon>
          <icon v-if="(item.seGest === 'S')" class="pointer app" name="riv-accept" scale="2" @click.native="approva(item)"></icon>
          <icon v-if="(item.notaDip !== '' || item.notaResp !== '' )" class="pointer" name="riv-addnotes" scale="2" @click.native="showNote(item)" 
          :style="[item.seGest === 'S' ? {'margin-right': '20px'} : {'margin-right': '5px'}]"
          ></icon>
        </div>
        <div class="riga" :class="item.tipoAssenza === 'FER' || item.tipoAssenza === 'SMW' ? 'RCR' : ''">
          <span v-if="item.dataDal === item.dataAl">
            {{$t('ferie.mesi.'+ item.dataDal.substring(4,6), {day:item.dataDal.substring(6,8), year:item.dataDal.substring(0,4)} )}}
          </span>
          <span v-else>
            {{$t('ferie.mesi.'+ item.dataDal.substring(4,6), {day:item.dataDal.substring(6,8), year:item.dataDal.substring(0,4)} )}} - 
            {{$t('ferie.mesi.'+ item.dataAl.substring(4,6), {day:item.dataAl.substring(6,8), year:item.dataAl.substring(0,4)} )}}
          </span>
          <span v-if="item.tipoAssenza === 'FER' || item.tipoAssenza === 'SMW'" class="orario">
            {{item.oraIni | formatHours}} - {{item.oraFin | formatHours}} ({{item.oreAssenza}})
          </span>
        </div>
        <div class="riga">
          <span class="tipo">
            {{item.descTipoAssenza}} ({{item.tipoAssenza}})
          </span>
        </div>
        <!--<div class="riga" style="height: 60px;">
            <span class="tipo">  {{item.notaDip}}</span>
        </div>-->
        <div class="riga" v-if="(item.seGest === 'S')">
            <el-input
              type="text"
              v-bind:placeholder="$t('ferie.resp')"
              v-model="item.notaResp"
              maxlength="60"
              style="width: 98%; margin-right: 5px"
            ></el-input>
        </div>
        <!--<div class="riga"  style="height: 60px;" v-else>
            <span class="label">{{ $t('ferie.resp')}}</span>
            <span class="value">  {{item.noteResp}}</span>
        </div>-->
      </div>
    </div>

    <div class="col-24">
      <el-pagination class="col-24" v-if="(nrItems > pag_for)"
        layout="prev, pager, next"
        :current-page="currentPage"
        :total="nrItems"
        :page-size="pag_for"
        :pager-count="5"
        @current-change="changePage">
      </el-pagination>
    </div>
    </div>

</template>

<script>
import FullCalendar from "@fullcalendar/vue";

export default {
  name: "AutorizzazioniFerieMobile",
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  props: ["tableHeight"],
  data() {
    return {
      loading: false,
      currentPage: 1,
      pag_for: 999,
      statoRich: 'A',
      anno: 0,
      anni: [],
      auth_VIP: false,
      vipChecked: false,
      stati: ['T', 'C', 'A', 'R'],
      richiesteSub: [],
      nrItems: 0,
      richiesta: {},
      showModalRichiesta: false,
      showModalNote: false,
      notaResp: '',
      notaDip: '',
      country: "",
      countries: []
    }
  },
  filters: {
    formatDate: function (date) {
      if (date !== '' && date !== undefined && date !== null) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return '-'
      }
    },
    formatHours: function(value) {
      if (value !== "") {
        return value.replace(/,/g, '.')
      } else {
        return ""
      }
    }
  },
  activated: function () {
    let anno = new Date().getFullYear()
    this.$set(this, 'anno', anno)
    this.anni = [anno - 1, anno, anno + 1]
    this.checkauth('authCongeVIP')
    this.getCountries()
  },
  deactivated: function() {
    this.currentPage = 1
    this.pag_for = 8
    this.statoRich = 'A'
    this.anno = 0
    this.$set(this, 'anni', [])
    this.auth_VIP = false
    this.vipChecked = false
    this.stati = ['T', 'C', 'A', 'R']
    this.$set(this, 'richiesteSub', [])
    this.nrItems = 0
    this.$set(this, 'richiesta', {})
    this.showModalRichiesta = false
    this.showModalNote = false
    this.notaResp = ''
    this.notaDip = ''
    this.country = ""
    this.$set(this, 'countries', [])
  },
  methods: {
    openModalRichiesta: function (rich) {
      this.$set(this, 'richiesta', rich)
      this.showModalRichiesta = true
    },
    openModalNote: function (rich) {
      this.$set(this, 'richiesta', rich)
      this.showModalNote = true
    },
    changePage: function (page) {
      this.currentPage = page
      this.getRichiesteSub()
    },
    change: function () {
      this.getRichiesteSub()
    },
    checkauth: function (auth) {
      this.loading = true
      this.$http.get('dipendente/' + this.$store.state.country + '/checkauth', {
        params: {
          auth: auth
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.auth_VIP = true
          } else {
            this.auth_VIP = false
          }
          this.loading = false
        })
    },
    getCountries: function () {
      //this.loading = true
      this.$set(this, 'countries', {})
      this.$http.get('ferie/' + this.$store.state.country + '/countries', {})
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'countries', response.body.data)
            if (this.countries.some(country => country.codice === this.$store.state.country)) {
              this.$set(this, 'country', this.$store.state.country)
              // Richiamo il servizio con l'elenco delle richieste solo se è resonsabile della propria country
              this.getRichiesteSub()
            } else if (response.body.data.length >= 1) {
              this.$set(this, 'country', response.body.data[0].codice)
              // Richiamo il servizio con l'elenco delle richieste nelcaso in cui si aresponsabile di uan sola country
              this.getRichiesteSub()
            } else {
              this.$set(this, 'country', "")
            }
          }
          //this.loading = false
        })
    },
    getRichiesteSub: function () {
      this.loading = true
      let country = this.country !== "" ? this.country : this.$store.state.country
      this.$http.get('ferie/' + country + '/richiestesub', {
        params: {
          pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
          pag_for: this.pag_for,
          pag_from: this.currentPage,
          anno: this.anno,
          statoRich: (this.statoRich === 'T') ? '' : this.statoRich,
          VIP: (this.vipChecked) ? '1' : null
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'richiesteSub', response.body.data)
            if (this.currentPage === 1) {
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$set(this, 'richiesteSub', [])
            this.currentPage = 1
            this.nrItems = 0
          }
          this.loading = false
        })
    },
    rifiuta: function(row) {
       this.$confirm(this.$i18n.t('ferie.rifiutare'), this.$i18n.t('ferie.titolo'), {
          confirmButtonText: this.$i18n.t('btn.approva'),
          cancelButtonText: this.$i18n.t('btn.annulla'),
          type: 'error',
          showClose: false,
          closeOnClickModal: false,
          customClass: 'el-message-box-mobile'
        }).then(() => {
          //console.log(row)
          this.setRichiesta(row, 'R')
        }).catch(() => {
          // Eventuale handler di annullamento cancellazione
        })
    },
    approva: function(row) {
       this.$confirm(this.$i18n.t('ferie.autorizzare'), this.$i18n.t('ferie.titolo'), {
          confirmButtonText: this.$i18n.t('btn.approva'),
          cancelButtonText: this.$i18n.t('btn.annulla'),
          type: 'success',
          showClose: false,
          closeOnClickModal: false,
          customClass: 'el-message-box-mobile'
        }).then(() => {
          //console.log(row)
          this.setRichiesta(row, 'C')
        }).catch(() => {
          // Eventuale handler di annullamento cancellazione
        })
    },
    setRichiesta: function (row,stato) {
      let country = this.country !== "" ? this.country : this.$store.state.country
      let obj = {
        notaRes: row.notaResp,
        id: row.id,
        stato: stato
      }
      this.$http.post('ferie/' + country + '/richiestaupdate', obj, {emulateJSON: true})
        .then(response => {
          if (response.body.rc === 0) {
            this.showModalRichiesta = false
            this.getRichiesteSub()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    showNote: function (row) {
      //this.notaDip = row.notaDip
      //this.notaResp = row.notaResp
      let message = ''
      message += row.notaDip !== '' ? '<strong>' + this.$i18n.t('ferie.dip') + '</strong><br>' + row.notaDip + '<br>' : ''
      message += row.notaResp !== '' ? '<strong>' + this.$i18n.t('ferie.resp') + '</strong><br>' + row.notaResp : ''
      this.$alert(message, this.$i18n.t('ferie.note'), {
          confirmButtonText: 'OK',
          customClass: 'el-message-box-mobile',
          dangerouslyUseHTMLString: true
        });
    },
    getStatoClass: function (stato) {
      switch (stato) {
        case 'A':
          return 'status-send'
        case 'C':
          return 'status-approved'
        case 'R':
          return 'status-rejected'
        default:
          return ''
      }
    }
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "@fullcalendar/core/main.css";
@import "@fullcalendar/daygrid/main.css";

.autorizzazioni-ferie-mobile {
  padding: 0;
  .elemento {
    margin-bottom: 0px;
    .my-label {
      &.center {
        text-align: center;
      }
    }
    .my-value {
      .el-switch {
        text-align: center;
      //float: right;
      //margin-right: 5px;
      }
    }
  } 

  input[type=checkbox] {
    margin-right: 12px;
    margin-top: 12px;
    transform: scale(2);
    float: right;
  }
  .el-checkbox {
    padding-right: 12px;
    .el-checkbox__inner {
      height: 20px;
      width: 20px;
      input{
        font-size: 18px;
      }
    }
  }
  
  .elenco-ferie {
    .scheda {
      border-radius: 5px;
      height: 100px;
      margin-bottom: 5px;
      margin-top: 5px;
      border: 1px solid #dddddd;
      &.segest {
        height: 140px;
      }
      .riga {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding-left: 5px;
        float: left;
        .set-font(@size: 13px, @color: @greenRiva, @weight: bold, @family:'os-regular');
        .nominativo {
          float: left;
          height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      
        span {
          float: left;
          line-height: 30px;
        }

        .fa-icon {
          float: right;
          height: 30px;          
          &.app {
            margin-top: 3px;
            color: #10d823;
          }
          &.rej {
            color: #f44336;
            margin-right: 5px;
            margin-left: 20px;          
          }
        }
        .orario {
          padding-left: 10px;
          color: @greenTick;
        }
        .saperatore {
          display: block;
          float: left;
          width: 20px;
          text-align: center;
        }
        .tipo {
          .set-font(@size: 13px, @color: @grayTesto, @family:'os-regular');
          //padding-left: 5px;
          text-align: left;
          float: left;
          width: 100%;
        }
        .label {
          .set-font(@size: 13px, @color: @grayTesto, @family:'os-regular');
          //padding-left: 5px;
          text-align: left;
          float: left;
          width: 80px;
        }
        .el-textarea {
          width: 98%;
          float: left;
          margin-top: 5px;
          .el-textarea__inner {
            padding-left: 5px;
            padding-right: 0px;
          }
        }
        .note {
          .set-font(@size: 13px, @color: @grayDark, @family:'os-regular');
          padding-left: 5px;
          text-align: left;
          display: block;
        }
      }
      &.A {
        border-left: 5px solid @orangeMedium;
      }
      &.C {
        border-left: 5px solid #c9db96;
      }
      &.R {
        border-left: 5px solid #f44336;
      }
    }
  }

  .action {
    height: 20px;
    line-height: 20px;
    span {
      float: right;
      .set-font(
        @size: 14px,
        @color: @grayDark,
        @weight: bold,
        @family: "os-regular"
      );
      text-transform: capitalize;
      padding-right: 15px;
    }
  }

  .el-pagination {
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FerieMobile/AutorizzazioniMobile.vue